import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from 'redux-persist/lib/storage';

import AuthReducer from "./authReducers";
import NoteReducer from "./noteReducers";
import BillingReducer from "./billingReducer";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth"], // notes and billing are always fetched fresh from the API
};

const rootReducer = combineReducers({
  auth: AuthReducer,
  notes: NoteReducer,
  billing: BillingReducer,
});

export default persistReducer(persistConfig, rootReducer);
